// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== 现代化登录页面样式 ==================== */

/* 主容器 - 左右分栏布局 */
.modern-signin-container {
  display: flex;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);
}

/* ==================== 左侧品牌区域 ==================== */
.signin-brand-section {
  flex: 1 1;
  background: linear-gradient(135deg, #f5f3ff 0%, #fde8f5 50%, #fff5e6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  position: relative;
  overflow: hidden;
}

.brand-content {
  max-width: 600px;
  z-index: 10;
  position: relative;
}

.brand-header {
  margin-bottom: 48px;
}

.brand-logo {
  margin-bottom: 24px;
  animation: fadeInDown 0.8s ease;
}

.brand-title {
  font-size: 48px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 16px;
  animation: fadeInDown 0.8s ease 0.2s both;
}

.brand-subtitle {
  font-size: 18px;
  color: #718096;
  line-height: 1.6;
  animation: fadeInDown 0.8s ease 0.4s both;
}

/* 特性卡片 */
.brand-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: fadeInLeft 0.8s ease 0.6s both;
}

.feature-card {
  background: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  padding: 24px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateX(8px);
  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.15);
}

.feature-card h3 {
  font-size: 18px;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 8px;
}

.feature-card p {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.6;
  margin: 0;
}

/* 装饰性形状 */
.decorative-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}

.shape {
  position: absolute;
  border-radius: 20px;
  opacity: 0.4;
}

.shape-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #fc8181 0%, #f56565 100%);
  bottom: 10%;
  right: 15%;
  animation: float 6s ease-in-out infinite;
}

.shape-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #f6ad55 0%, #ed8936 100%);
  top: 15%;
  right: 10%;
  animation: float 8s ease-in-out infinite 1s;
}

.shape-3 {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #d946ef 0%, #c026d3 100%);
  bottom: 25%;
  left: 10%;
  animation: float 7s ease-in-out infinite 2s;
}

.shape-4 {
  width: 180px;
  height: 180px;
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  top: 40%;
  left: 5%;
  animation: float 9s ease-in-out infinite 1.5s;
}

/* ==================== 右侧表单区域 ==================== */
.signin-form-section {
  flex: 0 0 550px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-shadow: -10px 0 40px rgba(0, 0, 0, 0.05);
}

.form-wrapper {
  width: 100%;
  max-width: 420px;
  animation: fadeInRight 0.8s ease;
}

/* ==================== 表单样式 ==================== */
.modern-signin-form {
  width: 100%;
}

.modern-form-title {
  margin-bottom: 32px;
}

.modern-form-title h2 {
  font-size: 32px;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.modern-form-group {
  margin-bottom: 24px;
}

.modern-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.modern-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  transition: all 0.3s ease;
  background: #f7fafc;
  color: #2d3748;
  box-sizing: border-box;
}

.modern-input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.modern-input.input-error {
  border-color: #fc8181;
  background: #fff5f5;
}

.error-message {
  display: block;
  color: #e53e3e;
  font-size: 13px;
  margin-top: 6px;
  font-weight: 500;
}

/* 表单选项 */
.modern-form-options {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #4a5568;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.modern-checkbox {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  cursor: pointer;
  border-radius: 4px;
}

/* 提交按钮 */
.modern-submit-btn {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.3);
  letter-spacing: 0.5px;
}

.modern-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.modern-submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.modern-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 注册链接 */
.modern-signup-link {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #718096;
}

.modern-signup-link a {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.modern-signup-link a:hover {
  color: #764ba2;
  text-decoration: underline;
}

/* ==================== 动画 ==================== */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-20px) rotate(5deg);
  }
  50% {
    transform: translateY(-10px) rotate(-5deg);
  }
  75% {
    transform: translateY(-25px) rotate(3deg);
  }
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 1024px) {
  .signin-brand-section {
    display: none;
  }
  
  .signin-form-section {
    flex: 1 1;
  }
}

@media (max-width: 640px) {
  .signin-form-section {
    padding: 20px;
  }
  
  .form-wrapper {
    max-width: 100%;
  }
  
  .modern-form-title h2 {
    font-size: 28px;
  }
}

/* ==================== 旧版样式保留（用于注册页面等） ==================== */
.signup-container{
    position: fixed; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    display: flex;
    flex-direction: column;
    width: 22rem;
    justify-content: center;
    align-content: center;
}

.signin-container{
    position: fixed; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    display: flex;
    flex-direction: column;
    width: 22rem;
    justify-content: center;
    align-content: center;
}

.button-container{
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
}

.form-title{
    display: flex;
    margin-bottom: 1rem;
    text-align: center;
    justify-content: center;
}

.form-container{
    display: flex;
    flex-direction: column;
}

.down-button-container{
    margin-top: 20rem;
}

.container{
    display: flex;
    flex-direction: column;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Auth.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,6DAA6D;AAC/D;;AAEA,qDAAqD;AACrD;EACE,SAAO;EACP,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,WAAW;EACX,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,QAAQ;EACR,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,WAAW;EACX,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,QAAQ;EACR,QAAQ;EACR,6CAA6C;AAC/C;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8DAA8D;AAC9D;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":["/* ==================== 现代化登录页面样式 ==================== */\n\n/* 主容器 - 左右分栏布局 */\n.modern-signin-container {\n  display: flex;\n  min-height: 100vh;\n  width: 100%;\n  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);\n}\n\n/* ==================== 左侧品牌区域 ==================== */\n.signin-brand-section {\n  flex: 1;\n  background: linear-gradient(135deg, #f5f3ff 0%, #fde8f5 50%, #fff5e6 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px;\n  position: relative;\n  overflow: hidden;\n}\n\n.brand-content {\n  max-width: 600px;\n  z-index: 10;\n  position: relative;\n}\n\n.brand-header {\n  margin-bottom: 48px;\n}\n\n.brand-logo {\n  margin-bottom: 24px;\n  animation: fadeInDown 0.8s ease;\n}\n\n.brand-title {\n  font-size: 48px;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 16px;\n  animation: fadeInDown 0.8s ease 0.2s both;\n}\n\n.brand-subtitle {\n  font-size: 18px;\n  color: #718096;\n  line-height: 1.6;\n  animation: fadeInDown 0.8s ease 0.4s both;\n}\n\n/* 特性卡片 */\n.brand-features {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: fadeInLeft 0.8s ease 0.6s both;\n}\n\n.feature-card {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  padding: 24px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.feature-card:hover {\n  transform: translateX(8px);\n  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.15);\n}\n\n.feature-card h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #667eea;\n  margin-bottom: 8px;\n}\n\n.feature-card p {\n  font-size: 14px;\n  color: #4a5568;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* 装饰性形状 */\n.decorative-shapes {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.shape {\n  position: absolute;\n  border-radius: 20px;\n  opacity: 0.4;\n}\n\n.shape-1 {\n  width: 200px;\n  height: 200px;\n  background: linear-gradient(135deg, #fc8181 0%, #f56565 100%);\n  bottom: 10%;\n  right: 15%;\n  animation: float 6s ease-in-out infinite;\n}\n\n.shape-2 {\n  width: 150px;\n  height: 150px;\n  background: linear-gradient(135deg, #f6ad55 0%, #ed8936 100%);\n  top: 15%;\n  right: 10%;\n  animation: float 8s ease-in-out infinite 1s;\n}\n\n.shape-3 {\n  width: 120px;\n  height: 120px;\n  background: linear-gradient(135deg, #d946ef 0%, #c026d3 100%);\n  bottom: 25%;\n  left: 10%;\n  animation: float 7s ease-in-out infinite 2s;\n}\n\n.shape-4 {\n  width: 180px;\n  height: 180px;\n  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);\n  top: 40%;\n  left: 5%;\n  animation: float 9s ease-in-out infinite 1.5s;\n}\n\n/* ==================== 右侧表单区域 ==================== */\n.signin-form-section {\n  flex: 0 0 550px;\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  box-shadow: -10px 0 40px rgba(0, 0, 0, 0.05);\n}\n\n.form-wrapper {\n  width: 100%;\n  max-width: 420px;\n  animation: fadeInRight 0.8s ease;\n}\n\n/* ==================== 表单样式 ==================== */\n.modern-signin-form {\n  width: 100%;\n}\n\n.modern-form-title {\n  margin-bottom: 32px;\n}\n\n.modern-form-title h2 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.modern-form-group {\n  margin-bottom: 24px;\n}\n\n.modern-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.modern-input {\n  width: 100%;\n  padding: 14px 16px;\n  font-size: 15px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  background: #f7fafc;\n  color: #2d3748;\n  box-sizing: border-box;\n}\n\n.modern-input:focus {\n  outline: none;\n  border-color: #667eea;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.modern-input.input-error {\n  border-color: #fc8181;\n  background: #fff5f5;\n}\n\n.error-message {\n  display: block;\n  color: #e53e3e;\n  font-size: 13px;\n  margin-top: 6px;\n  font-weight: 500;\n}\n\n/* 表单选项 */\n.modern-form-options {\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #4a5568;\n  cursor: pointer;\n  user-select: none;\n}\n\n.modern-checkbox {\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n/* 提交按钮 */\n.modern-submit-btn {\n  width: 100%;\n  padding: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.3);\n  letter-spacing: 0.5px;\n}\n\n.modern-submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.modern-submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.modern-submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* 注册链接 */\n.modern-signup-link {\n  text-align: center;\n  margin-top: 24px;\n  font-size: 14px;\n  color: #718096;\n}\n\n.modern-signup-link a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s ease;\n}\n\n.modern-signup-link a:hover {\n  color: #764ba2;\n  text-decoration: underline;\n}\n\n/* ==================== 动画 ==================== */\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  25% {\n    transform: translateY(-20px) rotate(5deg);\n  }\n  50% {\n    transform: translateY(-10px) rotate(-5deg);\n  }\n  75% {\n    transform: translateY(-25px) rotate(3deg);\n  }\n}\n\n/* ==================== 响应式设计 ==================== */\n@media (max-width: 1024px) {\n  .signin-brand-section {\n    display: none;\n  }\n  \n  .signin-form-section {\n    flex: 1;\n  }\n}\n\n@media (max-width: 640px) {\n  .signin-form-section {\n    padding: 20px;\n  }\n  \n  .form-wrapper {\n    max-width: 100%;\n  }\n  \n  .modern-form-title h2 {\n    font-size: 28px;\n  }\n}\n\n/* ==================== 旧版样式保留（用于注册页面等） ==================== */\n.signup-container{\n    position: fixed; \n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -60%);\n    display: flex;\n    flex-direction: column;\n    width: 22rem;\n    justify-content: center;\n    align-content: center;\n}\n\n.signin-container{\n    position: fixed; \n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -60%);\n    display: flex;\n    flex-direction: column;\n    width: 22rem;\n    justify-content: center;\n    align-content: center;\n}\n\n.button-container{\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n}\n\n.form-title{\n    display: flex;\n    margin-bottom: 1rem;\n    text-align: center;\n    justify-content: center;\n}\n\n.form-container{\n    display: flex;\n    flex-direction: column;\n}\n\n.down-button-container{\n    margin-top: 20rem;\n}\n\n.container{\n    display: flex;\n    flex-direction: column;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
